module.exports = __webpack_public_path__ + "static/media/code-alt.2c4f0d67.svg";